/* src/app/auth/components/register-page/register-page.component.scss */
.left-text {
  max-width: 400px;
}
@media (max-width: 767.98px) {
  .left-text {
    max-width: 100%;
  }
}
/*# sourceMappingURL=register-page.component.css.map */
